import { Grid } from '@mui/material';
import Button from '../../../components/button/button.component';
import { useContext, useEffect } from 'react';
import { CancelContext } from '../../../contexts/cancellation.context';
import { freshDeskReport, setCookie } from '../../../utils/generaFunctions';
import { Link, useNavigate } from 'react-router-dom';
import { reactivateSubscription } from '../../../utils/recurly.functions';

const Canceled = () => {
    const {userInfo, cancelInfo, setLoading, changeCancelInfo} = useContext(CancelContext);
    const navigate = useNavigate();
    useEffect(()=>{
        setCookie("cancellation-"+userInfo.email,"yes", 1/12);
        setLoading(false);
    })
    return (
        <Grid container className='confirmed-container'>
            <Grid container className='flex-vertical'>
                <Grid item className='title'>
                    <h1>{cancelInfo.value === "official_sub"?"Congrats, it’s official":"Your subscription has been canceled"}</h1>
                </Grid>
                <Grid item className='body-book' dangerouslySetInnerHTML={{__html:
                        cancelInfo.value === "official_sub"? `Congratulations on the beginning of a beautiful journey together! Your subscription will automatically end after you receive the “It’s Official” box.`:
                        `Thank you for being part of the Tum To Mom community! All scheduled charges have been canceled and you will not be billed again. If you have any questions at all, please don’t hesitate to <a className='body-black' href="mailto:support+cancel@tumtomom.com">contact our 24/7 support team</a>.`
                    }}>
                </Grid>
                <Grid item id='button-container' style={{display:cancelInfo.value === "official_sub"?"none":""}}>
                    <Link className={`button-link`} onClick={()=>{
                            changeCancelInfo({reactivated: true});
                            setLoading(true);
                            reactivateSubscription(userInfo.email, true).then((response)=>{
                                freshDeskReport(userInfo.email, userInfo.name, "Prevented From: "+ cancelInfo.text + (cancelInfo.otherText?", "+cancelInfo.otherText:""), "SysT1.0: Prevented","SysT1.0: Prevented", "SysT1.0: Reactivated", "SysT1.0: " + cancelInfo.tag).then((data)=>{
                                    navigate("../keep"+window.location.search);
                                })
                            }).catch(()=>{
                                navigate("../keep"+window.location.search);
                            })
                    }}><Button  text={"I made a mistake! reactivate now"}/></Link>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default Canceled;